import { useRoute } from '@nuxtjs/composition-api';
import { randomNumber } from '~/utils';
/**
 * Ротация баннеров
 * @param entries Объект с описанием частоты показа баннеров в процентах
 * Напр., {adfox: 50, infox: 10, smi2: 35, sparrow: 5}
 */
export function getBannersVisibility(entries = {}) {
    const values = Object.values(entries);
    if (!values?.length) {
        throw new Error('[getBannersVisibility] Передан пустой объект');
    }
    let sum = 0;
    for (const value of values) {
        if (value) {
            sum += value;
        }
    }
    if (sum !== 100) {
        throw new Error('[getBannersVisibility] Сумма всех значений должна быть равна 100');
    }
    const route = useRoute();
    const randomIndex = randomNumber(1, 100);
    const sortedEntries = Object.entries(entries)?.sort(([, a = 0], [, b = 0]) => a - b);
    let from = 1;
    return sortedEntries.reduce((obj, [key, value = 0]) => {
        const shouldShowBanner = () => {
            if (route.value.query?.rotatingBanner) {
                // Принудительный показ баннера по ключевому слову в гет-параметре (для дебага)
                // Напр., ?rotatingBanner=infox
                return route.value.query.rotatingBanner === key;
            }
            const to = value + from - 1;
            const shouldShowBanner = randomIndex >= from && randomIndex <= to;
            from += value;
            return shouldShowBanner;
        };
        obj[key] = shouldShowBanner();
        return obj;
    }, {});
}
